<template>
    <div class="dialog-wrapper">
        <div class="dialog-box" :style="{ width: width }">

            <div class="header"></div>
            <div class="dialog-title">{{title}}</div>

            <!--<div class="dialog-close" @click="$emit('exchange')" :style="{display: display}">确定</div>-->

            <div class="dialog-body"><slot></slot></div>

        </div>
    </div>
</template>

<script>
    export default {
        name: 'ExchangePrizeDialog',
        props: {
            title: String,
            width: String,
            display:String,
        },
    };
</script>

<style scoped lang="scss">
    .dialog-wrapper {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        z-index: 100;

    }
    .dialog-box {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: #fff;
        z-index: 101;
        border-radius: 10px;

    }
    .dialog-close {
        position: absolute;
        bottom: 0;
        width: 100%;
        background: #ea2d53;
        height: 40px;
        line-height: 40px;
        color: #FFFFFF;
        font-size: 1rem;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
    }
    .dialog-title {
        padding: 12px;
        color: #FFFFFF;
        font-size: 1rem;
        background: #ea2d53;
        display: none;
    }
    .dialog-body {
        padding: 10px 10px 50px;
    }

    .header {
        width: 100%;
        height: 110px;
        background: url("../assets/model.png") no-repeat;
        background-size: 100% 110px;
        margin-top: -50px;
    }
</style>
